export enum KpiTab {
  OVERVIEW = 'overview',
  IOU = 'iou',
  ANNOTATIONS = 'annotations',
}
